import { render, staticRenderFns } from "./TentUsage.vue?vue&type=template&id=b9041342&scoped=true"
import script from "./TentUsage.vue?vue&type=script&lang=ts"
export * from "./TentUsage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9041342",
  null
  
)

export default component.exports